(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-editorial-ui"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('garrnish-editorial'))customElements.define('garrnish-editorial',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;this.onClick=this.handleClick.bind(this);this.addEventListener('click',this.onClick);this.addEventListener('change',e=>{if(e.target.matches('[data-ge-dose]'))this.updateDose(e.target.value)});this.querySelectorAll('dialog').forEach(d=>{d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}});d.addEventListener('close',()=>{this.opener?.focus()})});this.updateDose(this.querySelector('[data-ge-dose]:checked')?.value||1);this.onBlock=e=>{const b=this.querySelector(`[data-block-id="${e.detail.blockId}"]`);if(!b)return;const filter=this.querySelector('[data-ge-filter="all"]');if(filter)this.filter(filter);b.scrollIntoView({block:'center'})};document.addEventListener('shopify:block:select',this.onBlock);const key=new URLSearchParams(location.search).get('benefit');const initial=Array.from(this.querySelectorAll('[data-ge-filter]')).find(b=>b.dataset.geFilter===key);if(initial)this.filter(initial);const anchors=this.querySelectorAll('[data-ge-anchor]');if(anchors.length){this.observer=new IntersectionObserver(entries=>{const active=entries.find(e=>e.isIntersecting);if(active)anchors.forEach(a=>{if(a.hash==='#'+active.target.id)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')})},{rootMargin:'-20% 0px -60% 0px'});this.querySelectorAll('[data-ge-benefit]').forEach(s=>this.observer.observe(s))}}
 disconnectedCallback(){document.removeEventListener('shopify:block:select',this.onBlock);this.observer?.disconnect()}
 handleClick(e){const open=e.target.closest('[data-ge-open]');if(open){const d=document.getElementById(open.dataset.geOpen);if(d){this.opener=open;d.showModal()}return}if(e.target.closest('[data-ge-close]')){e.target.closest('dialog')?.close();return}const filter=e.target.closest('[data-ge-filter]');if(filter)this.filter(filter)}
 filter(button){this.querySelectorAll('[data-ge-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;this.querySelectorAll('[data-ge-categories]').forEach(c=>{c.hidden=button.dataset.geFilter!=='all'&&!c.dataset.geCategories.split(' ').includes(button.dataset.geFilter);if(!c.hidden)count++});const sub=this.querySelector('[data-ge-subheading]');if(sub)sub.textContent=button.dataset.copy;const status=this.querySelector('[data-ge-count]');if(status)status.textContent=String(count)+' '+status.dataset.label}
 updateDose(value){const factor=Number(value);if(!Number.isFinite(factor)||factor<=0)return;const format=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:3}).format(n);this.querySelectorAll('[data-ge-amount]').forEach(el=>{el.textContent=format(Number(el.dataset.geAmount)*factor)});const servings=this.querySelector('[data-ge-servings]');if(servings)servings.textContent=format(Number(servings.dataset.geServings)/factor);const sachets=this.querySelector('[data-ge-sachets]');if(sachets)sachets.textContent=format(factor)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-supply-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const galleries = new Map();
  function setup(root) {
    root.querySelectorAll('.gs-product .wt-product__gallery').forEach(gallery => {
      if (galleries.has(gallery)) return;
      const buyBar = gallery.closest('.shopify-section').querySelector('.gss');
      const layout = gallery.closest('.wt-product');
      let frame;
      const update = () => {
        const desktop = window.innerWidth > 900;
        const button = gallery.querySelector(':scope > .gsg__ingredients');
        const buttonSpace = button ? button.offsetHeight + 14 : 0;
        const bottom = buyBar ? buyBar.getBoundingClientRect().height : 0;
        if (!desktop) {
          layout.style.removeProperty('--gs-gallery-column');
          layout.style.removeProperty('--gs-info-column');
          const image = Math.max(1, (gallery.getBoundingClientRect().width - 14 + 32 / 5) * 5 / 6);
          gallery.style.setProperty('--gs-thumb-size', `${Math.max(1, (image - 32) / 5)}px`);
          gallery.style.setProperty('--gs-image-size', `${image}px`);
          return;
        }
        // Desktop columns as the stylesheet splits them (gallery 1.2 : text 1, or the text at its fixed width on wide
        // screens), read from the layout's own width so the result never feeds back into itself.
        const width = layout.clientWidth;
        const styles = getComputedStyle(layout);
        const gap = parseFloat(styles.columnGap) || 0;
        const fixedInfo = parseFloat(styles.getPropertyValue('--gds-product-info')) || 0;
        const maxImage = parseFloat(styles.getPropertyValue('--gds-product-image-max')) || Infinity;
        const info = window.innerWidth >= 1376 && fixedInfo ? Math.min(fixedInfo, width - gap) : (width - gap) / 2.2;
        const column = width - gap - info;
        // The image is as large as its column allows, up to --gds-product-image-max, but it and the ingredient button
        // below it fit the screen while the nav is away (as it is in the purchase section): 24px above, and 24px clear
        // of the buy bar.
        const image = Math.max(1, Math.min((column - 14 + 32 / 5) * 5 / 6, window.innerHeight - 24 - buttonSpace - 24 - bottom, maxImage));
        const thumb = Math.max(1, (image - 32) / 5);
        gallery.style.setProperty('--gs-thumb-size', `${thumb}px`);
        gallery.style.setProperty('--gs-image-size', `${image}px`);
        // When the screen height or the size cap limits the image, the gallery column shrinks to fit it and gallery and text centre
        // together, so the spare width goes to the outer margins rather than between them.
        layout.style.setProperty('--gs-gallery-column', `${Math.floor(Math.min(column, thumb + 14 + image))}px`);
        layout.style.setProperty('--gs-info-column', `${Math.floor(info)}px`);
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(gallery);
      observer.observe(layout);
      if (buyBar) observer.observe(buyBar);
      const visibilityObserver = new MutationObserver(schedule);
      if (buyBar) visibilityObserver.observe(buyBar, { attributes:true, attributeFilter:['hidden'] });
      window.addEventListener('resize', schedule);
      galleries.set(gallery, () => {
        layout.style.removeProperty('--gs-gallery-column');
        layout.style.removeProperty('--gs-info-column');
        observer.disconnect();
        visibilityObserver.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', schedule);
      });
      update();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [gallery, cleanup] of galleries) if (event.target.contains(gallery)) { cleanup(); galleries.delete(gallery); }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
